export const API_BASE_URL = 'https://svr.pegasus-pms.co.ke/api/';

export const PEGASUS_URLS = {
  login: 'https://pegasus-pms.co.ke',
  signup: 'https://pegasus-pms.co.ke/signup',
};

export const CONTACT_INFO = {
  phone: ['+254712292899', '+254721655268'],
  email: 'mkieru55@gmail.com',
  address: 'Nairobi, Kenya',
};

export const COMPANY_INFO = {
  name: 'ITorama Property Management Agency',
  shortName: 'ITorama',
  founder: 'Mark Kieru',
  tagline: 'Your trusted partner in property management',
  description: 'Dedicated to maximizing your investment while minimizing the hassles that come with it.',
};

export const NAV_ITEMS = [
  { id: 'home', label: 'Home' },
  { id: 'why-us', label: 'Why Us' },
  { id: 'about', label: 'About' },
  { id: 'testimonials', label: 'Testimonials' },
  { id: 'team', label: 'Team' },
  { id: 'contact', label: 'Contact' },
];

export const STATS = [
  { value: '500+', label: 'Properties Managed' },
  { value: '98%', label: 'Client Satisfaction' },
  { value: '10+', label: 'Years Experience' },
  { value: '24/7', label: 'Support Available' },
];

export const WHY_US_FEATURES = [
  {
    id: 1,
    title: 'Experience & Expertise',
    description: 'Years of proven track record in property management with deep industry knowledge.',
    icon: 'WorkspacePremium',
  },
  {
    id: 2,
    title: 'Personalized Service',
    description: 'Tailored solutions to meet your unique property management needs.',
    icon: 'PersonOutline',
  },
  {
    id: 3,
    title: 'Full Transparency',
    description: 'Clear communication and detailed reporting on all property activities.',
    icon: 'Visibility',
  },
  {
    id: 4,
    title: 'Tenant Screening',
    description: 'Comprehensive vetting process to find reliable, quality tenants.',
    icon: 'FactCheck',
  },
  {
    id: 5,
    title: 'Property Maintenance',
    description: 'Proactive maintenance to preserve and enhance property value.',
    icon: 'HomeRepairService',
  },
  {
    id: 6,
    title: 'Technology & Innovation',
    description: 'Modern tools and systems for efficient property management.',
    icon: 'Devices',
  },
  {
    id: 7,
    title: 'Legal Compliance',
    description: 'Expert knowledge of property laws and regulations.',
    icon: 'Gavel',
  },
  {
    id: 8,
    title: 'Proven Results',
    description: 'Client testimonials and success stories speak for themselves.',
    icon: 'TrendingUp',
  },
  {
    id: 9,
    title: 'Customized Pricing',
    description: 'Flexible pricing plans designed to fit your budget.',
    icon: 'Payments',
  },
];

export const TESTIMONIALS = [
  {
    id: 1,
    name: 'James Mwangi',
    role: 'Property Investor',
    avatar: null,
    rating: 5,
    quote: 'ITorama has transformed how I manage my rental properties. Their professional approach and transparent reporting give me complete peace of mind.',
  },
  {
    id: 2,
    name: 'Sarah Wanjiku',
    role: 'Landlord',
    avatar: null,
    rating: 5,
    quote: 'The tenant screening process is thorough and has resulted in excellent, long-term tenants. I highly recommend their services.',
  },
  {
    id: 3,
    name: 'Peter Ochieng',
    role: 'Real Estate Developer',
    avatar: null,
    rating: 5,
    quote: 'Working with ITorama has been a game-changer for our portfolio. Their technology-driven approach sets them apart from other agencies.',
  },
  {
    id: 4,
    name: 'Grace Njeri',
    role: 'Property Owner',
    avatar: null,
    rating: 5,
    quote: 'From maintenance coordination to rent collection, every aspect is handled professionally. They truly care about their clients.',
  },
];

export const TEAM_MEMBERS = [
  {
    id: 1,
    name: 'Mark Kieru',
    role: 'Founder & CEO',
    bio: 'A seasoned real estate professional with a passion for delivering exceptional property management services.',
    avatar: null,
    social: {
      email: 'mkieru55@gmail.com',
      linkedin: null,
    },
  },
  {
    id: 2,
    name: 'Juliana Wanjiku',
    role: 'Operations Manager',
    bio: 'Ensures smooth day-to-day operations and maintains high service standards across all managed properties.',
    avatar: null,
    social: {
      email: null,
      linkedin: null,
    },
  },
  {
    id: 3,
    name: 'Kharbie',
    role: 'Property Coordinator',
    bio: 'Expert in tenant relations and property maintenance coordination with keen attention to detail.',
    avatar: null,
    social: {
      email: null,
      linkedin: null,
    },
  },
  {
    id: 4,
    name: 'Cindy Wanjiru',
    role: 'Finance & Accounts',
    bio: 'Handles all financial reporting and ensures accurate, timely rent collection and disbursement.',
    avatar: null,
    social: {
      email: null,
      linkedin: null,
    },
  },
];

export const SOCIAL_LINKS = {
  facebook: null,
  twitter: null,
  instagram: null,
  linkedin: null,
};
